import ClinicalHistoryBanner from './clinical-history-banner/ClinicalHistoryBanner';
import ClinicalHistoryBody from './clinical-history-body/ClinicalHistoryBody';
import { ClinicalHistory, ClinicalHistoryDocument, Diagnosis, PreviousClaimSummary } from '../../../domain/entities';
import { BlockingLoader } from '../../../ui/molecules';
import PreviousClaimSummariesList from '../../organisms/previous-claim-summaries/PreviousClaimSummariesList';

export interface ClinicalHistoryDetailsProps {
    clinicalHistory?: ClinicalHistory;
    onRedirectBack: () => Promise<void>;
    onUpdateValidation: (validation: boolean) => void;
    onUpdateNote: (note: string) => void;
    onAddDisease: (key: string) => void;
    onRemoveDisease: (key: string) => void;
    loading: boolean;
    readOnly: boolean;
    clinicalHistoryDocuments: ClinicalHistoryDocument[];
    diagnosisOptions: Diagnosis[];
    previousClaimSummaries?: PreviousClaimSummary[];
}

const ClinicalHistoryDetails = ({
    clinicalHistory,
    onRedirectBack,
    onUpdateValidation,
    onUpdateNote,
    onAddDisease,
    onRemoveDisease,
    loading,
    readOnly = false,
    clinicalHistoryDocuments,
    diagnosisOptions,
    previousClaimSummaries,
}: ClinicalHistoryDetailsProps) => {
    return (
        <>
            {!loading && (
                <div className="clinical-history-details clinical-history-details--container">
                    <ClinicalHistoryBanner handleIncidentRedirection={() => onRedirectBack()} />
                    <ClinicalHistoryBody
                        clinicalHistory={clinicalHistory}
                        readOnly={readOnly}
                        onUpdateValidation={onUpdateValidation}
                        onUpdateNote={onUpdateNote}
                        onAddDisease={onAddDisease}
                        onRemoveDisease={onRemoveDisease}
                        clinicalHistoryDocuments={clinicalHistoryDocuments}
                        diagnosisOptions={diagnosisOptions}
                    />
                    <PreviousClaimSummariesList previousClaimSummaries={previousClaimSummaries ?? []} />
                </div>
            )}

            {loading && <BlockingLoader />}
        </>
    );
};

export default ClinicalHistoryDetails;
